import React from 'react';
import {CodeListsGate} from 'services/codelists';
import {useAllCodeListIds} from 'services/codelists/hooks/useAllCodeListIds';
import {ThesaurusesGate} from 'services/thesaurus/components';
import {useAllThesaurusIds} from 'services/thesaurus/hooks/useAllThesaurusIds';
import type {LinkedValueSearchProps} from './types';
// eslint-disable-next-line import/no-cycle
import {LinkedValueSearchCore} from './LinkedValueSearchCore';

export const LinkedValueSearch: React.FC<LinkedValueSearchProps> = props => {
  const allCodelistIds = useAllCodeListIds();
  const thesaurusIds = useAllThesaurusIds();

  return (
    <CodeListsGate codeLists={allCodelistIds}>
      <ThesaurusesGate thesauruses={thesaurusIds}>
        <LinkedValueSearchCore {...props} />
      </ThesaurusesGate>
    </CodeListsGate>
  );
};
